<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <bread-crumb>
      <span class="text-uppercase" slot="title">{{ businessDetails.businessName }}</span>
      <ul class="m-subheader__BreadCrumbs m-nav m-nav--inline" slot="links">
        <li class="m-nav__item">
          <router-link :to="{ name: 'services', params: params }" class="m-nav__link">
            <span class="m-nav__link-text">
              Services
            </span>
          </router-link>
        </li>
        <li class="m-nav__separator">
          -
        </li>
        <li class="m-nav__item">
          <router-link :to="{ name: 'sbp', params: params }" class="m-nav__link">
            <span class="m-nav__link-text">
              SBP
            </span>
          </router-link>
        </li>
      </ul>
    </bread-crumb>
    <dash-content>
      <div v-if="showBusiness" id="businessDetails" slot="content">
        <apply-permit :business-id="businessDetails.businessId" v-if="showApplyPermitModal"
                      @closePermitModal="closePermitModal"></apply-permit>
        <payment @closePaymentModal="closePaymentModal" v-if="showPaymentModal"
                 :transaction-details="transactionDetails" card-tx-type="clear-invoices-sbp-card"
                 mpesa-tx-type="clear-invoices-sbp">
          <table slot="items" class="table table-striped table-bordered">
            <thead>
            <tr>
              <th>
                <strong>Item</strong>
              </th>
              <th>
                <strong>Amount</strong>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(invoice,index) in selectedInvoices" :key="index">
              <td>{{ invoice.invoiceNo }}</td>
              <td>KES {{ invoice.invoiceAmount }}</td>
            </tr>
            <tr>
              <td>
                <strong>TOTAL</strong>
              </td>
              <td>
                <strong>KES {{ sum }}</strong>
              </td>
            </tr>
            </tbody>
          </table>
        </payment>
        <ul class="nav nav-tabs m--margin-0" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#business">
              Business Details
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#history">
              Payment History
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div id="business" class="active tab-pane">
            <div class="row">
              <div class="col-md-6">
                <div class="m-portlet">
                  <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                      <div class="m-portlet__head-title">
                        <span class="m-portlet__head-icon">
                          <i class="flaticon-suitcase"></i>
                        </span>
                        <h3 class="m-portlet__head-text m--font-danger text-uppercase">
                          {{ businessDetails.businessName }}
                        </h3>
                      </div>
                    </div>
                    <div class="m-portlet__head-tools">
                      <span slot="actions" class="btn pull-right btn-success btn-sm" @click="showPermitModal">
                        <i class="fa fa-edit"></i> Apply For Permit
                      </span>
                    </div>
                  </div>
                  <div class="m-portlet__body">
                    <table class="table table-striped">
                      <tbody>
                      <tr>
                        <td width="40%">Business Number</td>
                        <td>{{ businessDetails.businessNo }}</td>
                      </tr>
                      <tr>
                        <td>Sub County</td>
                        <td>{{ businessDetails.subCountyName }}</td>
                      </tr>
                      <tr>
                        <td>Ward</td>
                        <td>{{ businessDetails.wardName }}</td>
                      </tr>
                      <tr>
                        <td>Business Activity Category</td>
                        <td>{{ businessDetails.businessActivityCategory }}</td>
                      </tr>
                      <tr>
                        <td>Business Activity</td>
                        <td>{{ businessDetails.businessActivity }}</td>
                      </tr>
                      <tr>
                        <td>Activity Code</td>
                        <td>{{ businessDetails.activityCode }}</td>
                      </tr>
                      <tr>
                        <td>Status</td>
                        <td>
                            <span class="badge" :class="statusClass[businessDetails.status]">
                              {{ status[businessDetails.status] }}
                            </span>
                        </td>
                      </tr>
                      <tr>
                        <td>Balance</td>
                        <td>
                          <strong>KES {{ businessDetails.permitBalance }}</strong>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="m-portlet m-portlet-bordered">
                  <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                      <div class="m-portlet__head-title">
                        <span class="m-portlet__head-icon">
                          <i class="flaticon-suitcase"></i>
                        </span>
                        <h3 class="m-portlet__head-text">
                          INVOICES
                        </h3>
                      </div>
                    </div>
                    <div class="m-portlet__head-tools">
                      <div v-if="invoices.length > 0" class="btn-group pull-right">
                        <button class="btn btn-default btn-sm" disabled>
                          KES {{ formatNumber(sum) }}
                        </button>
                        <button class="btn btn-success btn-sm" :disabled="sum === 0" @click="showPayModal">
                          Pay
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="m-portlet__body">
                    <table class="table table-striped table-bordered">
                      <thead>
                      <tr>
                        <th width="5%"></th>
                        <th>#Invoice</th>
                        <th>Year</th>
                        <th>Amount</th>
                        <th>Paid</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="invoice in invoices" :key="invoice.id">
                        <td>
                          <label class="m-checkbox m-checkbox--focus">
                            <input type="checkbox" :value="invoice" @change="getSum" v-model="selectedInvoices">
                            <span></span>
                          </label>
                        </td>
                        <td>{{ invoice.invoiceNo }}</td>
                        <td>{{ invoice.year }}</td>
                        <td>Kes {{ invoice.invoiceAmount }}</td>
                        <td>Kes {{ invoice.amountPaid }}</td>
                      </tr>
                      <tr v-if="invoices.length === 0">
                        <td colspan="5">
                          <small>No pending invoices found</small>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="history" class="tab-pane">
            <div class="m-portlet m-portlet-bordered">
              <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                  <div class="m-portlet__head-title">
                        <span class="m-portlet__head-icon">
                          <i class="flaticon-suitcase"></i>
                        </span>
                    <h3 class="m-portlet__head-text">
                      PAYMENT HISTORY
                    </h3>
                  </div>
                </div>
              </div>
              <div class="m-portlet__body">
                <sbp-payment-history></sbp-payment-history>
              </div>
            </div>
          </div>
        </div>
      </div>
    </dash-content>
  </div>

</template>
<script>
  import api from "../../../api";
  import Modal from "../../Modal";
  import helper from "../../../helpers";
  import BreadCrumb from "../../partials/BreadCrumb";
  import dashContent from "../../partials/Content";
  import applyPermit from "./partials/ApplyPermit";
  import Payment from "../../checkout/Payment";
  import sbpPaymentHistory from "./datatables/PaymentHistory"

  export default {
    name: "Business",
    data() {
      return {
        year: "",
        sum: 0,
        invoices: "",
        years: [],
        params: this.$route.params,
        showPaymentModal: false,
        showApplyPermitModal: false,
        selectedInvoices: [],
        businessDetails: {},
        showBusiness: false,
        transactionDetails: {},
        businessId: this.$route.params.businessId,
        token: this.$store.state.token || window.localStorage.getItem("token"),
        status: [
          "Pending Approval",
          "Active",
          "Edited",
          "Deactivation Request",
          "Inactive",
          "Deleted"
        ],
        statusClass: [
          "badge-warning",
          "badge-success",
          "badge-warning",
          "badge-warning",
          "badge-danger",
          "badge-danger"
        ]
      };
    },
    components: {
      Modal,
      BreadCrumb,
      Payment,
      sbpPaymentHistory,
      dashContent,
      applyPermit
    },
    methods: {
      getBusiness() {
        const txType = "get-business-details";
        helper.loading(true);
        api
          .request(txType, {token: this.token, businessId: this.businessId})
          .then(response => {
            if (response.data.status === "00") {
              this.showBusiness = true;
              this.businessDetails = response.data.businessDetails;
              helper.loading(false);
            } else {
              helper.info({
                show: true,
                message: response.data.message
              });
            }
          })
          .catch(() => {
            helper.error({
              show: true,
              message: "An error occured. Please try again later."
            });
          });
      },
      getInvoices() {
        const txType = "get-uncleared-invoices-sbp";
        api
          .request(txType, {token: this.token, businessId: this.businessId})
          .then(response => {
            if (response.data.status === "00") {
              this.invoices = response.data.invoices;
            } else {
              this.invoices = [];
              console.log("No invoices found");
            }
          });
      },
      showPayModal() {
        if (this.selectedInvoices.length === 0) {
          helper.errorAlert("Please select at least one invoce");
          return false;
        }

        let invoices = [];
        for (let invoice of this.selectedInvoices) {
          invoices.push({
            invoiceNo: invoice.invoiceNo,
            amount: String(
              Number(invoice.invoiceAmount) - Number(invoice.amountPaid)
            )
          });
        }

        this.transactionDetails = {
          token: this.token,
          moduleId: String(helper.getModuleId("SBP").id),
          totalAmount: String(this.sum),
          invoices: invoices,
          businessId: this.businessId,
          countyId: this.params.countyId
        };
        document.body.classList.add("modal-open");
        this.showPaymentModal = true;
      },
      showPermitModal() {
        document.body.classList.add("modal-open");
        this.showApplyPermitModal = true;
      },
      closePermitModal(invoices) {
        document.body.classList.remove("modal-open");
        if (invoices) {
          this.invoices = invoices;
          this.updateBalance(this.invoices);
        }
        this.showApplyPermitModal = false;
      },
      closePaymentModal() {
        document.body.classList.remove("modal-open");
        this.showPaymentModal = false;
        this.transactionDetails = {};
        this.selectedInvoices = [];
        this.sum = 0;
        this.getInvoices();
      },
      getSum() {
        var sum = 0;
        for (let invoice of this.selectedInvoices) {
          sum += Number(invoice.invoiceAmount) - Number(invoice.amountPaid);
        }
        this.sum = sum;
      },
      formatNumber(number) {
        return helper.formatNumber(number);
      },
      updateBalance(invoices) {
        let sum = 0;
        for (let invoice of invoices) {
          sum = Number(sum) + Number(invoice.invoiceAmount);
        }
        this.businessDetails.permitBalance = sum;
      }
    },
    created: function () {
      this.getBusiness();
      this.getInvoices();
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/services/sbp/Business.vue